// src/belediye/pages/NewApplicationsPage.js
import React from 'react';
import ApplicationsPage from './ApplicationsPage';

const NewApplicationsPage = () => {
  return <ApplicationsPage statusName="yeni" pageTitle="Yeni Başvurular" />;
};

export default NewApplicationsPage;
